import { History } from "history";
import PropTypes from "prop-types";
import React, { useLayoutEffect, useState } from "react";
import { Router } from "react-router-dom";

interface IHistoryRouterProperties {
  children: React.ReactNode;
  history: History;
}

/**
 * A custom router component that synchronizes its state with the provided `history` object.
 * This allows us to create an external history component that we can modify in functions outside
 * a React component.
 *
 * @param children - The child components to be rendered within the router.
 * @param history - The history object from React Router.
 */
export default function HistoryRouter({ children, history }: IHistoryRouterProperties) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router location={state.location} navigationType={state.action} navigator={history}>
      {children}
    </Router>
  );
}
HistoryRouter.propTypes = {
  children: PropTypes.node.isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};
